// Globally Registered Components
import { app } from '@/provider/app';
import router from '@/router';
import { initDetailRoutes } from '@/views/detail/detail.router';

// Style imports
import 'primeicons/primeicons.css'; // prime icons
import './assets/scss/bryntumCalendar/customTheme.css'; // bryntum calendar custom theme
import './assets/scss/bryntumCalendar/calendar.scss'; // bryntum calendar overwrites
import 'primeflex/primeflex.css'; // primeflex utility classes

// Google Material Icons
import 'material-icons/iconfont/material-icons.css';

import './assets/scss/main.scss'; // our styles

(async () => {
  await initDetailRoutes(router);
  app.use(router);

  if (window.settings.isOffice) {
    // Initialize Office Add-in Start-Up
    // The Mount must be load only wenn Add-In is loaded
    await window.Office.onReady();
    window.vm = app.mount('#app');
  } else {
    window.vm = app.mount('#app');
  }
})();
